import { render, staticRenderFns } from "./OptionalProductGroup.vue?vue&type=template&id=0c934ce0&scoped=true&"
import script from "./OptionalProductGroup.vue?vue&type=script&lang=ts&"
export * from "./OptionalProductGroup.vue?vue&type=script&lang=ts&"
import style0 from "./OptionalProductGroup.vue?vue&type=style&index=0&id=0c934ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c934ce0",
  null
  
)

export default component.exports